import React from 'react'
import analytics from '@/shared-utils/analytics'
import FlightsRecentSearchCard from './FlightsRecentSearchCard'
import BundleHugWithBanner from './BundleHugWithBanner'
import { PackageSearchParamsType, FlyRecentSearchData } from '../types'

function fireOnContinueSearchClick() {
  analytics.fireEvent({
    category: 'FLIGHT_HOME',
    action: 'flight recent search',
    label: 'continue search'
  })
}

function fireOnBundleNowClick() {
  analytics.fireEvent({
    category: 'FLIGHT_HOME',
    action: 'flight recent search',
    label: 'bundle banner'
  })
}

export default function FlightRecentSearchWithBanner({
  searchData,
  packageSearchParams
}: {
  searchData: FlyRecentSearchData
  packageSearchParams: PackageSearchParamsType
}) {
  return (
    <FlightsRecentSearchCard
      searchData={searchData}
      onContinueSearchClick={fireOnContinueSearchClick}
    >
      <BundleHugWithBanner
        packageSearchParams={packageSearchParams}
        onBundleNowClick={fireOnBundleNowClick}
      />
    </FlightsRecentSearchCard>
  )
}
